import type { CertificatePricingCatalogItem } from "@/services/certificatePricingCatalogService";

/**
 * Customer-facing certificate / product name for checkout summary and similar UI.
 * Uses `requests.user.requestTypes.{targetType}` when present; otherwise catalog description or slug.
 */
export function certificateCatalogDisplayLabel(
  catalogItem: CertificatePricingCatalogItem | undefined,
  t: (key: string, options?: { defaultValue?: string }) => string,
): string {
  if (!catalogItem) return "—";
  return t(`requests.user.requestTypes.${catalogItem.targetType}`, {
    defaultValue: catalogItem.description?.trim() || catalogItem.targetType,
  });
}
